/**
 * Created by daan on 8/2/16.
 */

;(function($) {
  $.fn.resetFormElement = function() {
    this.wrap('<form>')
      .closest('form')
      .get(0)
      .reset()
    this.unwrap()
    return this
  }

  $(document).on('bless', function(evt, data) {
    var $elm = $(evt.target)
    $elm.find('.image-upload').each(function() {
      var $wrapper = $(this)
      var $file = $wrapper.find('input[type=file][data-auto-upload]')
      var $fakeButton = $wrapper.find(
        '.image-upload__select-file, .image-upload__change-file',
      )
      var $placeholders = $wrapper.find('.image-upload__placeholders')
      var placeholderTemplate = $wrapper.find('script[name=placeholder]').html()
      var field = $file.data('field')
      $fakeButton.on('click', function(e) {
        $file.trigger('click')
        e.preventDefault()
      })
      $wrapper.on('change', 'input[type=hidden]', function(evt) {
        var $input = $(evt.target)
        var $imageWrapper = $input.closest('.image-upload__placeholder')
        var val = $input.val()
        if (val == '') {
          $imageWrapper.css({ 'background-image': 'none' })
        } else {
          var url
          console.log('field', field)
          switch (field) {
            case 'url':
              url = val
              break
            case 'id':
            default:
              url = $file.data('preview-url').replace('/id', '/' + val)
              break
          }
          $imageWrapper.css({ 'background-image': 'url(' + url + ')' })
        }
        $wrapper.toggleClass('image-upload--empty', val == '')
      })
      $wrapper
        .find('input[type=hidden]')
        .filter(function() {
          return !!this.value
        })
        .trigger('change')
      $wrapper.on('change', 'input[type=file]', function() {
        $($file[0].files).each(function(index, file) {
          if ($file.data('mime-pattern')) {
            var pattern = new RegExp($file.data('mime-pattern'))
            if (!pattern.test(file.type)) {
              $wrapper.addClass('image-upload--error')
              return false
            }
          }
          if (!$file.attr('multiple')) {
            $placeholders.html('')
          }
          var $placeholder = $(placeholderTemplate)
          $placeholders.append($placeholder)
          var $input = $placeholder.find('input[type=hidden]')
          var fd = new FormData()
          fd.append($file.attr('name'), file)
          $wrapper.addClass('image-upload--uploading')
          $wrapper.removeClass('image-upload--error')
          $fakeButton.each(function(i, button) {
            $(button)
              .prop('disabled', true)
              .text('Please wait')
          })
          $.ajax({
            url: $file.data('auto-upload'),
            data: fd,
            processData: false,
            contentType: false,
            headers: {
              Accept: 'application/json',
            },
            xhrFields: {
              withCredentials: true,
            },
            type: 'POST',
            success: function(data) {
              $input.val(data[field]).change()
            },
            complete: function() {
              $wrapper.removeClass('image-upload--uploading')
              $input.trigger('uploaded')
              $fakeButton.each(function(i, button) {
                var $button = $(button)
                $button.prop('disabled', false).text($button.attr('data-text'))
              })
            },
            error: function(xhr) {
              $wrapper.addClass('image-upload--error')
              if (xhr.responseJSON) {
                console.error(xhr.responseJSON.message)
              }
              console.log('error', arguments)
            },
          })
        })
        $file.resetFormElement()
      })

      $wrapper.on('click', '.image-upload__delete-file', function(evt) {
        $wrapper.find('.image-upload__placeholder').remove()
        $wrapper.addClass('image-upload--empty')
      })
    })
  })
})(jQuery)
